module.exports = __webpack_public_path__ + "flaticon.3bd85d2252cd982c9e36.eot";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/multi-sports/flaticon.eot
// module id = ../../../../../src/scss/multi-sports/flaticon.eot
// module chunks = styles